import React from 'react';
import Reveal from './Reveal';
import '../CSS/Faq.css';

export interface FaqItem {
  q: string;
  a: string;
}

// Accessible accordion built on <details>. The same items feed the FAQPage structured data (see seoConfig.ts),
// so what is marked up is always what is visible on the page.
const FaqSection: React.FC<{ title?: string; items: FaqItem[]; tint?: boolean }> = ({ title = 'Frequently Asked Questions', items, tint = false }) => (
  <div className={`faq-section${tint ? ' faq-tint' : ''}`}>
    <Reveal className="faq-container">
      <h2 className="faq-title">{title}</h2>
      <div className="faq-list">
        {items.map((item) => (
          <details className="faq-item" key={item.q}>
            <summary>{item.q}</summary>
            <p>{item.a}</p>
          </details>
        ))}
      </div>
    </Reveal>
  </div>
);

export default FaqSection;
